import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom'; // Assuming you're using react-router-dom for navigation
import { getAdminUsers, deleteAdminUser, suspendAdminUser } from '../../services/adminApi';
import ReusableAdminTable from './ReusableAdminTable'; // Adjust path as needed
import { fetchUserJogetProfileApi } from '../../services/api';

// UI & Icons
import { Button, Badge } from 'react-bootstrap';
import { FiEdit, FiTrash2, FiPauseCircle } from 'react-icons/fi';

const AdminUsersList = ({ roleCode, title }) => {
    // Component-specific state
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate(); // Initialize navigate hook

    // Component-specific data fetching logic
    const fetchUsers = async () => {
        setIsLoading(true);
        try {
            const res = await getAdminUsers(roleCode);
            setUsers(res.data);
        } catch (error) {
            console.error(`Error fetching ${title}`, error);
            setUsers([]); // Set to empty array on error
        } finally {
            setIsLoading(false);
        }
    };

    // Re-fetch data when the roleCode prop changes
    useEffect(() => {
        fetchUsers();
    }, [roleCode]);

    
    const handleSuspend = async (id) => {
    const userToSuspend = users.find(user => user.id === id);
        if (!userToSuspend) return;

        const confirmMessage = userToSuspend.is_suspended
            ? "Are you sure you want to unsuspend this user?"
            : "Are you sure you want to suspend this user?";

        if (window.confirm(confirmMessage)) {
            try {
                // await suspendAdminUser(id);
                // fetchUsers(); 
                await suspendAdminUser(id);

        setUsers(prev =>
        prev.map(user =>
            user.id === id
            ? { ...user, is_suspended: !user.is_suspended }
            : user
        )
        );
            } catch (error) {
                console.error("Failed to suspend/unsuspend user:", error);
                alert("Could not update user suspension status.");
            }
        }
    };



    // Component-specific business logic (delete, edit navigation, etc.)
    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this user?")) {
            try {
                await deleteAdminUser(id);
                fetchUsers(); // Refresh the list after deletion
            } catch (error) {
                console.error("Failed to delete user:", error);
                alert("Could not delete the user.");
            }
        }
    };

   

    const handleEdit = (id) => {

    // Candidate
    if (String(roleCode) === "300") {
        // navigate(`/admin/candidate-profile/${id}`);
        console.log("REDIRECTING TO:", `/admin/candidate-profile/${id}`);

navigate(`/admin/candidate-profile/${id}`);
        return;
    }

    // Director
    if (String(roleCode) === "200") {
        navigate(`/admin/director-profile/${id}`);
        return;
    }

    // Casting Director
    if (String(roleCode) === "400") {
        navigate(`/admin/casting-profile/${id}`);
        return;
    }
};

    // const handleAddNew = () => {
    //     console.log(`Navigating to add new user for role: ${roleCode}`);
    // };
    const handleAddNew = () => {

    // Candidate
    if (String(roleCode) === "300") {
        navigate('/admin/candidate-profile/add');
        return;
    }

    // Director
    if (String(roleCode) === "200") {
        navigate('/admin/director-profile/add');
        return;
    }

    // Casting Director
    if (String(roleCode) === "400") {
        navigate('/admin/casting-profile/add');
        return;
    }
};

    // Component-specific column definitions, memoized for performance
    const columns = useMemo(() => [
        { accessorKey: 'id', header: 'ID' },
        { accessorKey: 'full_name', header: 'Name' },
        { accessorKey: 'email', header: 'Email' },
        { accessorKey: 'mobile_no', header: 'Phone' },
        {
            accessorKey: 'is_verified',
            header: 'Verification Status', // More descriptive header
            cell: info => (
                <Badge pill bg={info.getValue() ? 'success' : 'warning'}>
                    {info.getValue() ? 'Verified' : 'Pending Verification'}
                </Badge>
            )
        },
        {
            accessorKey: 'is_suspended',
            header: 'Account Status', // More descriptive header
            cell: info => (
                <Badge pill bg={info.getValue() ? 'danger' : 'success'}>
                    {info.getValue() ? 'Suspended' : 'Active'}
                </Badge>
            )
        },
        {
            id: 'actions',
            header: 'Actions',
            cell: ({ row }) => {
                const user = row.original;
                return (
                    <div className="d-flex gap-2">
                        <Button variant="outline-primary" size="sm" onClick={() => handleEdit(user.id)} aria-label="Edit User">
                          {/* <Button variant="outline-primary" size="sm" aria-label="Edit User"> */}

                            <FiEdit />
                        </Button>
                        <Button variant="outline-danger" size="sm" onClick={() => handleDelete(user.id)} aria-label="Delete User">
                            <FiTrash2 />
                        </Button>
                        <Button
                            variant={user.is_suspended ? "outline-warning" : "outline-secondary"}
                            size="sm"
                            onClick={() => handleSuspend(user.id)}
                            aria-label={user.is_suspended ? "Unsuspend User" : "Suspend User"}
                        >
                            <FiPauseCircle />
                        </Button>
                    </div>
                );
            }
        }
    ], [users,handleEdit, handleDelete, handleSuspend]); // Added dependencies for functions

    // The entire UI is now delegated to the reusable component
    return (
        <ReusableAdminTable
            data={users}
            columns={columns}
            isLoading={isLoading}
            title={title}
            onAddNew={handleAddNew}
            addNewButtonText={`Add New ${title.replace(/s$/, '')}`} // More robust way to remove trailing 's'
            searchPlaceholder={`Search in ${title}...`}
            exportCsvFilename={`${title.toLowerCase().replace(/ /g, '_')}.csv`}
        />
    );
};

export default AdminUsersList;